import React, { useEffect, useRef } from "react";
import { useQuill } from "react-quilljs";
import "quill/dist/quill.snow.css";
import "./RichTextEditor.css";

const RichTextEditor = ({ onChange, name, value = "" }) => {
  const { quill, quillRef } = useQuill();
  const hasInitialized = useRef(false);

  useEffect(() => {
    if (!quill || hasInitialized.current) return;
    hasInitialized.current = true;

    // ✅ Prevent auto focus scroll
    const originalFocus = quill.focus.bind(quill);
    quill.focus = function (...args) {
      // If suppress flag is on, skip focus entirely
      if (this._suppressFocus) return;
      // Otherwise call original focus
      originalFocus(...args);
    };

    // ✅ Hide image button
    const toolbar = quill.getModule("toolbar");
    if (toolbar) {
      toolbar.container
        .querySelectorAll(".ql-image")
        .forEach((btn) => (btn.style.display = "none"));
    }

    // ✅ Handle text changes
    quill.on("text-change", () => {
      const html = quill.root.innerHTML;
      onChange(name, html);
    });

    // ✅ Force blur after mount (to ensure no active focus)
    setTimeout(() => {
      const scrollY = window.scrollY; // 👈 save current scroll position
      quill._suppressFocus = true;
      quill.blur();
      document.activeElement?.blur();
      window.scrollTo(0, scrollY); // 👈 restore scroll position
      quill._suppressFocus = false;
    }, 100);
  }, [quill]);

  // ✅ Handle updating existing value
  // useEffect(() => {
  //   if (quill && typeof value === "string") {
  //     const current = quill.root.innerHTML;
  //     if (current !== value) {
  //       const scrollY = window.scrollY; // remember scroll position
  //       quill._suppressFocus = true;
  //       quill.clipboard.dangerouslyPasteHTML(value);
  //       window.scrollTo(0, scrollY); // restore scroll position
  //       quill._suppressFocus = false;
  //     }
  //   }
  // }, [value, quill]);

  useEffect(() => {
  if (quill && typeof value === "string") {
    const current = quill.root.innerHTML;

    if (
      current !== value &&
      document.activeElement !== quill.root // ✅ prevent override while typing
    ) {
      const scrollY = window.scrollY; // 👈 save scroll position
      quill._suppressFocus = true;
      quill.clipboard.dangerouslyPasteHTML(value);
      quill.blur();
      document.activeElement?.blur();
      window.scrollTo(0, scrollY); // 👈 restore scroll position
      quill._suppressFocus = false;
    }
  }
}, [value, quill]);

  return (
    <div style={{ scrollBehavior: "auto" }}>
      <div ref={quillRef} />
    </div>
  );
};

export default RichTextEditor;
